const STORAGE_KEY = (accountId, userId) => `painel.view.${accountId}.${userId}`;

const loadFromStorage = (accountId, userId) => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY(accountId, userId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const persist = (accountId, userId, payload) => {
  try {
    window.localStorage.setItem(
      STORAGE_KEY(accountId, userId),
      JSON.stringify(payload)
    );
  } catch {
    /* ignore quota */
  }
};

const defaultState = () => ({
  statusFilter: ['pending', 'confirmed'],
  viewMode: 'day',
  hydrated: false,
  hydrationKey: null,
});

const state = defaultState();

const getters = {
  getStatusFilter: $s => new Set($s.statusFilter),
  getViewMode: $s => $s.viewMode,
};

const mutations = {
  HYDRATE($s, { accountId, userId }) {
    const stored = loadFromStorage(accountId, userId) || {};
    $s.statusFilter = stored.statusFilter || ['pending', 'confirmed'];
    $s.viewMode = stored.viewMode || 'day';
    $s.hydrated = true;
    $s.hydrationKey = `${accountId}.${userId}`;
  },
  SET_STATUS_FILTER($s, list) {
    $s.statusFilter = list;
  },
  SET_VIEW_MODE($s, mode) {
    $s.viewMode = mode;
  },
};

const actions = {
  hydrate: ({ commit }, { accountId, userId }) =>
    commit('HYDRATE', { accountId, userId }),

  toggleStatus: ({ commit, state: _state }, status) => {
    const current = new Set(_state.statusFilter);
    if (current.has(status)) current.delete(status);
    else current.add(status);
    const next = Array.from(current);
    commit('SET_STATUS_FILTER', next);
    const [accountId, userId] = (_state.hydrationKey || '.').split('.');
    persist(accountId, userId, {
      hiddenProfessionalIds: [],
      statusFilter: next,
      viewMode: _state.viewMode,
    });
  },

  setViewMode: ({ commit, state: _state }, mode) => {
    commit('SET_VIEW_MODE', mode);
    const [accountId, userId] = (_state.hydrationKey || '.').split('.');
    persist(accountId, userId, {
      hiddenProfessionalIds: [],
      statusFilter: _state.statusFilter,
      viewMode: mode,
    });
  },
};

export default { namespaced: true, state, getters, mutations, actions };
